








































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { queryPayOrder, downloadOrder } from '@/api/product/order'
import { queryAllProduct } from '@/api/product/product'
import Product from '@/model/product/product'
import PayOrder from '@/model/product/payOrder'
import { WorkOrderExcelParam } from '@/model/coupon/coupon'
import moment from 'moment'
import { isMasterWithCache } from 'ykd-base/role'
import Page, { PageParam } from '@/model/common/page'

@Component({
  components: {}
})
export default class Order extends Vue {
  private data: any = []
  private dateFormat: string = 'YYYY/MM/DD'
  private monthFormat: string = 'YYYY/MM'
  private payStartTime: string = ''
  private payEndTime: string = ''
  private purchaserMobile: string = ''
  private productIds: string[] = []

  private defalutEndTime: any = this.format(new Date())
  private products: Product[] = []
  private payOrders: any = []
  private pagination: any = {}
  private pageSize: number = 10
  private current: number = 1
  private total: number = 0
  private OrderExcelParam: WorkOrderExcelParam = {}
  private columns: any = [
    {
      title: '序号',
      key: 'tags',
      dataIndex: 'number',
      className: 'coulmn-money'
    },
    {
      title: '订单号',
      dataIndex: 'orderNumber',
      className: 'coulmn-money'
    },

    {
      title: '支付时间',
      dataIndex: 'payTime',
      className: 'coulmn-money'
    },

    {
      title: '商品名称',
      dataIndex: 'productName',
      className: 'coulmn-money'
    },
    {
      title: '支付类型',
      dataIndex: 'payType',
      className: 'coulmn-money'
    },

    {
      title: '购买人',
      dataIndex: 'purchaserAccountName',
      className: 'coulmn-money',
      scopedSlots: { customRender: 'purchaserAccountName' }
    },
    {
      title: '购买人学校',
      dataIndex: 'purchaserSchool',
      className: 'coulmn-money'
    },
    {
      title: '购买金额',
      dataIndex: 'payAmount',
      className: 'coulmn-money'
    },
    {
      title: '优惠卷金额',
      dataIndex: 'couponAmount',
      className: 'coulmn-money'
    },
    {
      title: '优惠卷编号',
      dataIndex: 'couponNumber',
      className: 'coulmn-money'
    },
    {
      title: '优惠券发送人',
      dataIndex: 'partnerAccountName',
      className: 'coulmn-money',
      scopedSlots: { customRender: 'partnerAccountName' }
    }
  ]
  private moment: Function = moment
  private defalutStartTime: any = this.format(new Date(new Date().setDate(1)))
  async mounted() {
    const res = await isMasterWithCache()
    if (!res) {
      //跳转官网
      this.$router.push({
        path: '/personal/user/m'
      })
    }
    //查询所有商品
    this.products = await queryAllProduct()
    //查询数据
    //获取当月第一天
    var d = new Date()
      //获取当前时间
    ;(this.payStartTime = this.format(new Date(d.setDate(1)))),
      (this.payEndTime = this.format(new Date())),
      (this.payOrders = await queryPayOrder({
        payStartTime: this.payStartTime,
        payEndTime: this.payEndTime,
        purchaserMobile: this.purchaserMobile,
        productId: this.productIds
      }))

    this.total = this.payOrders.totalCount
    this.initData(this.payOrders.data)
  }

  private initData(payOrders: any) {
    //初始化表格数据
    if (payOrders && payOrders.length > 0) {
      for (let i = 0; i < payOrders.length; i++) {
        this.data.push({
          key: i,
          number: payOrders[i].number,
          orderNumber: payOrders[i].orderNumber,
          payTime: payOrders[i].payTime,
          productName: payOrders[i].productName,
          payType: payOrders[i].payType,
          purchaserAccountName: [
            // payOrders[i].purchaserAccount!
            //   ? payOrders[i].purchaserAccount!.user
            //     ? payOrders[i].purchaserAccount!.user.nickName
            //     : ''
            //   : '',
            //
            this.getName(payOrders[i].purchaserAccount!),
            payOrders[i].purchaserAccount!
          ],
          purchaserSchool: payOrders[i].purchaserSchool,
          payAmount: payOrders[i].payAmount,
          couponAmount: payOrders[i].couponAmount,
          couponNumber: payOrders[i].couponNumber
            ? payOrders[i].couponNumber
            : 0,
          partnerAccountName: payOrders[i].partnerAccount
            ? [
                this.getName(payOrders[i].partnerAccount!),
                payOrders[i].partnerAccount!
              ]
            : []
        })
      }
    }
  }

  async onShowChange(current: any, pageSize: any) {
    this.data = []
    this.payOrders = await queryPayOrder({
      payStartTime: this.payStartTime,
      payEndTime: this.payEndTime,
      purchaserMobile: this.purchaserMobile,
      productIds: this.productIds,
      pagination: current - 1,
      pageSize: pageSize
    })
    this.current = current
    this.pageSize = pageSize
    this.total = this.payOrders.totalCount
    //this.current = this.payOrders.totalPage;
    this.initData(this.payOrders.data)
  }
  getName(account: any) {
    if (account) {
      if (account.user && account.user.name) {
        return account.user.name
      } else if (account.accountName) {
        return account.accountName
      } else if (account.user && account.user.nickName) {
        return account.user.nickName
      }
    }
  }
  @Watch('purchaserMobile')
  private initMobilePage() {
    this.current = 1
  }
  @Watch('productIds')
  private initProductPage() {
    this.current = 1
  }
  @Watch('payEndTime')
  private initTimePage() {
    this.current = 1
  }
  async onShowSizeChange(current: any, pageSize: any) {
    this.pageSize = pageSize
  }
  onChange(date: any, dateString: any) {
    if (date.length > 0) {
      this.payStartTime = this.format(new Date(date[0]._d))
      this.payEndTime = this.format(new Date(date[1]._d))
    } else {
      this.payStartTime = ''
      this.payEndTime = ''
    }
  }

  format(date: any) {
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    var d = date.getDate()
    d = d < 10 ? '0' + d : d
    return y + '-' + m + '-' + d + ' 23:59:59'
  }
  handleChangeProduct(value: any) {
    this.productIds = value
  }
  popupScroll() {
    console.log('popupScroll')
  }
  async query() {
    this.total = 0
    this.data = []
    this.payOrders = await queryPayOrder({
      payStartTime: this.payStartTime,
      payEndTime: this.payEndTime,
      purchaserMobile: this.purchaserMobile,
      productIds: this.productIds,
      pagination: this.current - 1,
      pageSize: this.pageSize
    })
    this.total = this.payOrders.totalCount
    this.initData(this.payOrders.data)
  }
  async excel() {
    // await downloadOrder({
    //   payOrders: this.payOrders
    // });

    window.open(
      `https://www.youkeda.com/api/productorder/download?payStartTime=${
        this.payStartTime
      }&payEndTime=${this.payEndTime}&purchaserMobile=${
        this.purchaserMobile
      }&productIds=${this.productIds.join(',')}&pagination=${this.current -
        1}&pageSize=${this.pageSize}`
    )
  }
}
